// ----------------- import external dependencies ------------
import React, { useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

interface Props {
  heading: React.ReactNode;
  children: React.ReactNode;
}

function AccordionDropDown({ heading, children }: Props) {
  // -------- component state managers --------
  const [open, setOpen] = useState(false);

  return (
    <>
      <div>
        <div
          onClick={() => {
            setOpen(!open);
          }}
          className="flex items-center gap-2"
        >
          {heading} <span>{open ? <FaAngleDown /> : <FaAngleUp />}</span>
        </div>
        {open && children}
      </div>
    </>
  );
}

export default AccordionDropDown;
